import jsPDF from "jspdf";
import { CONTACT } from "./api";

const BUSINESS_ADDRESS = "Shyam Nagar, Kanpur";

let _fontCache = null;
async function loadFonts() {
  if (_fontCache) return _fontCache;
  const toB64 = async (url) => {
    const buf = await (await fetch(url)).arrayBuffer();
    const bytes = new Uint8Array(buf);
    let bin = "";
    const chunk = 8192;
    for (let i = 0; i < bytes.length; i += chunk) bin += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
    return btoa(bin);
  };
  const [reg, bold] = await Promise.all([toB64("/fonts/TQSans-Regular.ttf"), toB64("/fonts/TQSans-Bold.ttf")]);
  _fontCache = { reg, bold };
  return _fontCache;
}

function registerFonts(doc, fonts) {
  doc.addFileToVFS("TQSans-Regular.ttf", fonts.reg);
  doc.addFont("TQSans-Regular.ttf", "TQSans", "normal");
  doc.addFileToVFS("TQSans-Bold.ttf", fonts.bold);
  doc.addFont("TQSans-Bold.ttf", "TQSans", "bold");
}

function fmtDateTime(iso) {
  const d = iso ? new Date(iso) : new Date();
  return d.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata", day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: true,
  }) + " IST";
}

function fmtEvent(date, time) {
  try {
    const d = new Date(`${date}T${time}`);
    const dd = d.toLocaleDateString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric" });
    const tt = d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true });
    return `${dd} @ ${tt}`;
  } catch { return `${date} @ ${time}`; }
}

const inr = (n) => "\u20B9 " + Number(n || 0).toLocaleString("en-IN") + ".00";

export async function generateReceiptPDF(b) {
  const fonts = await loadFonts();
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  registerFonts(doc, fonts);
  const F = "TQSans";
  const W = doc.internal.pageSize.getWidth();
  const M = 48;
  let y = 60;
  const green = [18, 79, 49];
  const gray = [90, 90, 90];

  doc.setTextColor(...green);
  doc.setFont(F, "bold"); doc.setFontSize(26);
  doc.text("THE QUISINE", W / 2, y, { align: "center" });
  y += 22;
  doc.setFont(F, "normal"); doc.setFontSize(13); doc.setTextColor(...gray);
  doc.text("Cloud Kitchen & Caterers", W / 2, y, { align: "center" });
  y += 20;
  doc.setFontSize(12); doc.setTextColor(...green);
  doc.text(`${BUSINESS_ADDRESS}  \u00B7  ${CONTACT.phone.replace("+91", "")}`, W / 2, y, { align: "center" });
  y += 22;

  doc.setDrawColor(200, 190, 170); doc.setLineDashPattern([2, 2], 0);
  doc.line(M, y, W - M, y); doc.setLineDashPattern([], 0);
  y += 22;

  doc.setFont(F, "normal"); doc.setFontSize(11); doc.setTextColor(...gray);
  doc.text(fmtDateTime(b.paid_at || b.created_at), M, y);
  doc.setFont(F, "bold");
  doc.text(`Receipt ${b.receipt_no || ""}`, W - M, y, { align: "right" });
  y += 20;
  doc.setFont(F, "bold"); doc.setFontSize(18); doc.setTextColor(...green);
  doc.text("RECEIPT", W / 2, y, { align: "center" });
  y += 16;
  doc.setDrawColor(200, 190, 170); doc.setLineDashPattern([2, 2], 0);
  doc.line(M, y, W - M, y); doc.setLineDashPattern([], 0);
  y += 26;

  const row = (label, value) => {
    doc.setFont(F, "bold"); doc.setFontSize(11); doc.setTextColor(...green);
    doc.text(label, M, y);
    doc.setFont(F, "normal"); doc.setTextColor(40, 40, 40);
    doc.text(String(value), W - M, y, { align: "right" });
    y += 20;
  };
  row("Name", b.name);
  row("Mobile", b.phone);
  row("Address", `${b.address}, ${b.city} ${b.pincode || ""}`.trim());
  row("Persons", b.persons);
  row("Event", fmtEvent(b.event_date, b.event_time));
  row("Preference", b.without_onion_garlic ? "Without Onion & Garlic" : "Regular");
  if (b.cooking_instructions) row("Instructions", b.cooking_instructions);
  y += 6;

  const section = (title, list) => {
    doc.setFont(F, "bold"); doc.setFontSize(13); doc.setTextColor(...green);
    doc.text(title, M, y); y += 8;
    doc.setDrawColor(200, 190, 170); doc.line(M, y, W - M, y); y += 16;
    doc.setFont(F, "normal"); doc.setFontSize(11); doc.setTextColor(40, 40, 40);
    list.forEach((it) => { doc.text(`\u2022  ${it}`, M + 8, y); y += 18; });
    y += 8;
  };
  section("MAIN MENU", (b.items || []).map((i) => i.dish));
  section("CUSTOM ITEMS", b.custom_items || ["Salad", "Papad", "Disposal"]);

  doc.setDrawColor(200, 190, 170); doc.line(M, y, W - M, y); y += 24;
  const totalRow = (label, value, big) => {
    doc.setFont(F, "bold"); doc.setFontSize(big ? 15 : 13); doc.setTextColor(...green);
    doc.text(label, M, y);
    doc.text(value, W - M, y, { align: "right" });
    y += big ? 26 : 24;
  };
  totalRow("Total Amount", inr(b.total_amount), true);
  totalRow("Advance Paid", inr(b.advance_paid), false);
  totalRow("Balance Due", inr(b.balance_due), true);

  y += 14;
  doc.setFont(F, "normal"); doc.setFontSize(11); doc.setTextColor(...gray);
  doc.text("Thank you for choosing The Quisine  \u00B7  Free delivery on all orders", W / 2, y, { align: "center" });

  doc.save(`Quisine-Receipt-${(b.receipt_no || "").replace("#", "")}.pdf`);
}
